import { useState, useEffect, useRef, useCallback } from 'react'
import KeyboardArrowRightTwoToneIcon from '@mui/icons-material/KeyboardArrowRightTwoTone';
import KeyboardArrowLeftTwoToneIcon from '@mui/icons-material/KeyboardArrowLeftTwoTone';
import './galleryslider.css'
import CircularProgress from '@mui/material/CircularProgress';

const ImagePlaceholder = ({ children }) => <div className='image-loader placeholder-container'>{children}</div>

const ImageLoader = ({ src, alt, ...props }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    const handleLoad = () => {
        setIsLoading(false);
        setError(false);
    };

    const handleError = () => {
        setIsLoading(false);
        setError(true);
    };

    return (
        <>
            {isLoading && <ImagePlaceholder> <CircularProgress /></ImagePlaceholder>}
            {error && <ImagePlaceholder>
                <span className='image-loader error-message'>Error loading image</span>
            </ImagePlaceholder>}
            <img
                src={src}
                alt={alt}
                onLoad={handleLoad}
                onError={handleError}
                className="gallery-item"
                style={{ display: isLoading || error ? 'none' : 'block' }} // Hide the img while loading or on error
                {...props} />
        </>
    );
};

export default function GallerySlider({ photos }) {

    const scrollRef = useRef(null);

    // const [scrollableWidth, setScrollableWidth] = useState(0)
    const [sliderWidth, setSliderWidth] = useState(0)
    const [isAtStart, setIsAtStart] = useState(true)
    const [isAtEnd, setIsAtEnd] = useState(false)

    // const scrollToPosition = (scrollContainer, offset) => {
    //     if (scrollContainer && scrollContainer.current) {
    //         scrollContainer.current.scrollTo({
    //             left: scrollContainer.current.scrollLeft + offset,
    //             behavior: 'smooth' // Optional: for smooth animation
    //         });
    //     }
    // };

    const checkScrollPositions = () => {
        if (scrollRef.current) {
            const { scrollLeft, clientWidth, scrollWidth } = scrollRef.current;

            const atStart = scrollLeft === 0;
            console.log('atStart:', atStart);
            setIsAtStart(atStart);

            const atEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) < 1;
            console.log('atEnd:', atEnd);
            setIsAtEnd(atEnd);
        }
    };

    // 2. Create a memoized callback function that uses the ref
    const scrollToPosition = useCallback((scrollContainer, scrollFactor) => {
        if (scrollContainer && scrollContainer.current) {
            const { clientWidth, scrollWidth } = scrollRef.current
            console.log('scrollWidth:', scrollWidth);
            console.log('clientWidth : ', clientWidth);
            // TODO: this is a temporary fix for the scrollwidth being too small at first scroll action - debug the issue later
            // var sliderWidth2 = 500
            // if (clientWidth > 500) {
            //     sliderWidth2 = clientWidth
            // }
            var scrollDelta = clientWidth * scrollFactor
            console.log('scrollDelta: ', scrollDelta)
            scrollContainer.current.scrollTo({
                left: scrollContainer.current.scrollLeft + scrollDelta,
                behavior: 'smooth' // Optional: for smooth animation
            });
        }
    }, []); // Empty dependency array means this function is created once


    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.addEventListener('scroll', checkScrollPositions);
        }
        return () => { // Clean up the event listener when the component unmounts
            if (scrollRef.current) {
                scrollRef.current.removeEventListener('scroll', checkScrollPositions);
            }
        };
    }, []);

    return (
        <div className='gallery-container'>
            <div onClick={() => scrollToPosition(scrollRef, -1)}
                className={`gallery-slider-btn left-arrow ${isAtStart === false ? 'enabled-slider-btn' : 'disabled-slider-btn'}`}>
                <KeyboardArrowLeftTwoToneIcon />
            </div>
            <div ref={scrollRef}
                className="gallery-slider">
                {photos.map((photo, i) => <ImageLoader key={i} src={photo.url}
                    alt={photo.description} />)}
            </div>
            <div onClick={() => scrollToPosition(scrollRef, 1)}
                className={`gallery-slider-btn right-arrow ${isAtEnd === false ? 'enabled-slider-btn' : 'disabled-slider-btn'}`} >
                <KeyboardArrowRightTwoToneIcon />
            </div>
        </div>
    )
}

/** NOT USED - KEEPING FOR REFERENCE TEMPORARILY */
export function GallerySingleViewSlider({ photos }) {

    const [activeImage, setActiveImage] = useState(0)

    const goToNextImage = () => {
        if (activeImage === photos.length - 1) {
            setActiveImage(0);
            return;
        }
        setActiveImage(activeImage + 1);
        console.log(activeImage);
    };

    const goToPreviousImage = () => {
        if (activeImage === 0) {
            setActiveImage(photos.length - 1);
            return;
        }
        setActiveImage(activeImage - 1);
        console.log(activeImage);
    };

    return (
        <div className="gallery-slider">
            <div onClick={goToPreviousImage}
                className='gallery-slider-btn left-arrow'>
                <KeyboardArrowLeftTwoToneIcon />
            </div>
            <img className='gallery-item' src={photos[activeImage].url} alt={photos[activeImage].description} />

            <div onClick={goToNextImage}
                className='gallery-slider-btn right-arrow' >
                <KeyboardArrowRightTwoToneIcon />
            </div>
        </div>
    )
}